var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%"}},[_c('mainHeader'),_c('div',{staticClass:"body"},[_c('leftMenu'),_c('div',{staticClass:"router-view"},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }